import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { CartTotalsComponent } from '@spartacus/cart/base/components'
import { ActiveCartFacade, Cart, MultiCartFacade, OrderEntry } from '@spartacus/cart/base/root'
import { GlobalMessageType, OCC_USER_ID_CURRENT, RoutingService } from '@spartacus/core'
import { Observable } from 'rxjs'
import { filter, switchMap, take } from 'rxjs/operators'
import { CustomRoutes } from '../../../../models/enum/custom-routes.enum'
import { SharedValue } from '../../../../models/enum/shared.enum'
import { CustomCartService } from '../../../../services/custom-cart.service'
import { CustomGlobalMessageService } from '../../../../services/shared/custom-global-message/custom-global-message.service'
import { SharedService } from '../../../../services/shared/shared.service'
import { UserPermissionService } from '../../../../services/user-permission/user-permission.service'

@Component({
    selector: 'app-custom-cart-totals',
    templateUrl: './custom-cart-totals.component.html',
    styleUrls: ['./custom-cart-totals.component.scss'],
    standalone: false
})
export class CustomCartTotalsComponent extends CartTotalsComponent implements OnInit {
  public showLoader = true
  public disableSimulate = true
  public saveCart: boolean = false
  totalAmount: any
  userMinimumSaleOrderAmount: any

  entries$: Observable<any>

  constructor(
    // TODO:Spartacus - The type of property 'activeCartService: ActiveCartService' changed to: 'activeCartService: ActiveCartFacade'
    protected activeCartService: ActiveCartFacade,
    public sharedService: SharedService,
    public routingService: RoutingService,
    public customCartService: CustomCartService,
    public changeDetectorRef: ChangeDetectorRef,
    // TODO:Spartacus - Property 'multiCartService' was removed from Class 'ActiveCartService'. Use multiCartFacade instead.
    public multiCartService: MultiCartFacade,
    public globalMessageService: CustomGlobalMessageService,
    public userPermissionService: UserPermissionService
  ) {
    super(activeCartService)
  }

  // cart$: Observable<Cart>;

  public ngOnInit(): void {
    //  super.ngOnInit();
    this.onSimulateCart()

    this.cart$ = this.activeCartService.getActive()

    this.userPermissionService.getUserMinimumSaleOrderAmount().subscribe((res) => {
      this.userMinimumSaleOrderAmount = res
    })

    this.entries$ = this.activeCartService.getEntries().pipe(filter((entries) => entries.length > 0))
  }

  public onSimulateCart(): void {
    this.sharedService.disableSimulate = true
    this.sharedService.showSimulationLoader = true
    this.simulateCart()
  }

  private simulateCart(): void {
    let cartId
    // TODO:Spartacus - The type of property 'activeCartService: ActiveCartService' changed to: 'activeCartService: ActiveCartFacade'
    this.activeCartService
      .getActiveCartId()
      .pipe(
        switchMap((id) => {
          cartId = id
          if (cartId) {
            return this.customCartService.simulateCart(cartId)
          }
        }),
        take(1)
      )
      .subscribe(
        (sCart) => {
          if (!Object.keys(sCart)?.length) {
            this.errorOnSimulate({ key: 'shared.error.noSimulation' })
            return
          }

          if (sCart?.hasErrors) {
            this.errorOnSimulate(sCart.errors)
            return
          }

          this.sharedService.creditBlockedSimulation = sCart?.creditCheckStatus !== 'OK'
          // TODO:Spartacus - Property 'multiCartService' was removed from Class 'ActiveCartService'. Use multiCartFacade instead.
          this.multiCartService.loadCart({
            cartId,
            userId: OCC_USER_ID_CURRENT,
            extraData: { active: true }
          })
          this.customCartService.validateItemQuantity()
          this.showLoader = false
          this.sharedService.disableSimulate = true
          this.sharedService.showSimulationLoader = false
          this.changeDetectorRef.detectChanges()
        },
        (err) => {
          this.errorOnSimulate(err.message)
        }
      )
  }

  public onCheckout(): void {
    if (this.sharedService.isUserCreditHold) {
      this.sharedService.showCreditHoldMessage()
      return
    }

    // TODO:Spartacus - The type of property 'activeCartService: ActiveCartService' changed to: 'activeCartService: ActiveCartFacade'
    this.activeCartService.getActive().subscribe((res) => {
      if (res.totalPrice) {
        this.totalAmount = res.totalPrice.value
      }
    })

    if (this.userMinimumSaleOrderAmount != '' && this.totalAmount < this.userMinimumSaleOrderAmount) {
      this.sharedService.showTotalAmountLessMessage(this.userMinimumSaleOrderAmount)
      return
    }

    this.routingService.goByUrl('checkout/payment-type')
  }

  public disableCheckout(cart: Cart): boolean {
    return (
      this.sharedService.isUserCreditHold ||
      !this.sharedService.disableSimulate ||
      this.sharedService.showSimulationLoader
    )
  }

  public findOutOfStockItems(items: OrderEntry[]): boolean {
    if (items?.length) {
      for (const item of items) {
        if (item.product?.stock?.stockLevelStatus === 'outOfStock') {
          return true
        }
      }
    }
    return false
  }

  private errorOnSimulate(message: any): void {
    this.globalMessageService.add(message, GlobalMessageType.MSG_TYPE_ERROR)
    this.showLoader = false
    this.sharedService.showSimulationLoader = false
    this.sharedService.disableSimulate = false
    this.changeDetectorRef.detectChanges()
  }

  public onSaveCart(cartId: string): void {
    this.saveCart = true
    this.customCartService.savecart(cartId).subscribe(
      () => {
        this.globalMessageService.add({ key: 'cart.saveCartSuccess' }, GlobalMessageType.MSG_TYPE_CONFIRMATION)
        // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
        this.routingService.go({
          cxRoute: CustomRoutes.SAVED_CARTS
        })
      },
      (error) => {
        this.globalMessageService.add(SharedValue.errorTryAgain, GlobalMessageType.MSG_TYPE_ERROR)
      }
    )
  }
}
